import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
// @ts-ignore
import BcDialog from '@/components/Dialog.vue';
let DeviceStability = class DeviceStability extends Vue {
    constructor() {
        super();
        this.snackbar = new CBcSnackbar();
        this.loading = false;
        this.list = [];
        this.total = 0;
        this.summary = {
            totalDevices: 0,
            avgSuccessRate: 0,
            avgMtbf: 0,
            totalHospitals: 0
        };
        // 搜索选项
        this.searchOptions = {
            hospitalId: null,
            deviceType: '',
            serial: null,
            year: new Date().getFullYear(),
            month: null
        };
        // 折线图相关
        this.chart = null;
        this.resizeObserver = null;
        this.chartData = [];
        this.selectedSerialName = '';
        // 月份统计表
        this.monthlyData = [];
        // 临床机器表
        this.deviceData = [];
        this.deviceTotal = 0;
        this.deviceOptions = {
            page: 1,
            itemsPerPage: 15
        };
        this.deviceAverages = null;
        this.dialog = {
            visible: false,
            loading: false,
            title: ''
        };
        this.formData = {};
        this.dataLoading = {
            chart: false,
            device: false,
            monthly: false
        };
        this.deviceStabilityData = {};
        const that = this;
    }
    get monthlyHeaders() {
        const opsLabel = this.operationsLabel;
        const base = [
            { text: '月份', value: 'month', width: 60, align: 'center' },
            { text: '设备数量(No.)', value: 'deviceCount', width: 80, align: 'center' },
            { text: '使用时长', value: 'usageHours', width: 80, align: 'center' },
            { text: opsLabel, value: 'totalOperations', width: 80, align: 'center' },
            { text: '故障数量', value: 'totalFaults', width: 80, align: 'center' },
            { text: '人为故障', value: 'humanFaults', width: 80, align: 'center' },
            { text: '非配药时故障', value: 'nonDispenseFaults', width: 90, align: 'center' },
            { text: '成功率', value: 'successRate', width: 80, align: 'center' },
            { text: 'MTBF', value: 'mtbf', width: 80, align: 'center' },
            { text: '去除人为MTBF', value: 'mtbfExcludeHuman', width: 100, align: 'center' },
            { text: '最长无故障时长', value: 'maxNoFaultHours', width: 100, align: 'center' }
        ];
        if (this.showBottles) {
            base.splice(4, 0, { text: '总瓶数', value: 'totalBottles', width: 80, align: 'center' });
        }
        return base;
    }
    get deviceHeaders() {
        const opsLabel = this.operationsLabel;
        const base = [
            { text: '年月', value: 'yearMonth', width: 80, align: 'center' },
            { text: '机器编号', value: 'deviceNo', width: 90, align: 'center' },
            { text: '使用医院', value: 'hospitalName', width: 120, align: 'center' },
            { text: '使用时长（小时）', value: 'usageHours', width: 80, align: 'center' },
            { text: opsLabel, value: 'totalOperations', width: 80, align: 'center' },
            { text: '故障数量', value: 'totalFaults', width: 80, align: 'center' },
            { text: '设备故障', value: 'machineFaults', width: 80, align: 'center' },
            { text: '人为故障', value: 'humanFaults', width: 80, align: 'center' },
            { text: '非配药时故障', value: 'nonDispenseFaults', width: 90, align: 'center' },
            { text: '成功率', value: 'successRate', width: 80, align: 'center' },
            { text: 'MTBF', value: 'mtbf', width: 80, align: 'center' },
            { text: '去除人为MTBF', value: 'mtbfExcludeHuman', width: 100, align: 'center' },
            { text: '最长无故障时长', value: 'maxNoFaultHours', width: 100, align: 'center' },
            { text: '最后使用日期', value: 'lastUsedDate', width: 100, align: 'center' }
        ];
        if (this.showBottles) {
            base.splice(5, 0, { text: '总瓶数', value: 'totalBottles', width: 80, align: 'center' });
            base.splice(10, 0, { text: '每小时瓶数', value: 'bottlesPerHour', width: 90, align: 'center' });
        }
        return base;
    }
    // 年份选项
    get yearOptions() {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let i = currentYear; i >= currentYear - 5; i--) {
            years.push({ text: i.toString(), value: i, key: `year${i}` });
        }
        return years;
    }
    // 导出数据
    async exportData(type) {
        const that = this;
        try {
            if (type === 'all') {
                // 导出所有数据
                const monthlySheet = that.monthlyData.map((item) => ({
                    '月份': `${item.month}月`,
                    '使用设备数量': item.deviceCount,
                    '使用时长(小时)': item.usageHours,
                    '总瓶数': item.totalBottles,
                    '非配药时故障数量': item.nonDispenseFaults,
                    '人为故障': item.humanFaults,
                    'MTBF': item.mtbf,
                    '去除人为MTBF': item.mtbfExcludeHuman,
                    '平均每小时瓶数': item.bottlesPerHour,
                    '最长无故障运行时长': item.maxNoFaultTime
                }));
                const deviceSheet = that.deviceData.map((item) => ({
                    '机器编号': item.deviceCode,
                    '使用医院': item.hospitalName,
                    '使用时长(小时)': item.usageHours,
                    '总瓶数': item.totalBottles,
                    '非配药时故障数量': item.nonDispenseFaults,
                    '人为故障': item.humanFaults,
                    'MTBF': item.mtbf,
                    '去除人为MTBF': item.mtbfExcludeHuman,
                    '平均每小时瓶数': item.bottlesPerHour,
                    '最长无故障运行时长': item.maxNoFaultTime,
                    '最后使用日期': item.lastUsedDate
                }));
                that.$message.success('导出功能开发中...');
            }
            else if (type === 'monthly') {
                that.$message.success('月份统计导出功能开发中...');
            }
            else if (type === 'device') {
                that.$message.success('设备统计导出功能开发中...');
            }
        }
        catch (error) {
            console.error('导出失败:', error);
            that.$message.error('导出失败');
        }
    }
    // 月份选项
    get monthOptions() {
        return [
            { text: '全年', value: null, key: 'all' },
            { text: '1月', value: 1, key: 'month1' },
            { text: '2月', value: 2, key: 'month2' },
            { text: '3月', value: 3, key: 'month3' },
            { text: '4月', value: 4, key: 'month4' },
            { text: '5月', value: 5, key: 'month5' },
            { text: '6月', value: 6, key: 'month6' },
            { text: '7月', value: 7, key: 'month7' },
            { text: '8月', value: 8, key: 'month8' },
            { text: '9月', value: 9, key: 'month9' },
            { text: '10月', value: 10, key: 'month10' },
            { text: '11月', value: 11, key: 'month11' },
            { text: '12月', value: 12, key: 'month12' }
        ];
    }
    // 设备序列列表
    get deviceSerialList() {
        return this.listSerial || [];
    }
    get hospitalsListComputed() {
        return this.hospitalsList || [];
    }
    get routeQuery() {
        const that = this;
        return that.$router.currentRoute.query || {};
    }
    get dynamicHeight() {
        return `${window.innerHeight - 200}px`;
    }
    get serialItem() {
        return (this.listSerial || []).find(it => it.serial === this.searchOptions.serial);
    }
    get deviceCategory() {
        const serial = this.searchOptions.serial || '';
        const item = this.serialItem;
        const name = item ? item.name || '' : '';
        if (/pd|al|xl|ab/i.test(serial))
            return 'pd';
        if (/ew-/i.test(serial) || /洗消/i.test(name))
            return 'washer';
        if (/iemc/i.test(serial) || /存储柜/i.test(name))
            return 'cabinet';
        if (/^(bc-rt|wrt)/i.test(serial) || /呼吸训练/i.test(name))
            return 'breath';
        return 'pd';
    }
    get operationsLabel() {
        switch (this.deviceCategory) {
            case 'pd': return '总袋数';
            case 'washer': return '总条数';
            case 'cabinet': return '总次数';
            case 'breath': return '总次数';
            default: return '总次数';
        }
    }
    get showBottles() {
        return this.deviceCategory === 'pd';
    }
    get hourlyRateLabel() {
        switch (this.deviceCategory) {
            case 'pd': return '平均每小时瓶数';
            case 'washer': return '平均每小时条数';
            case 'cabinet': return '平均每小时次数';
            case 'breath': return '平均每小时次数';
            default: return '平均每小时瓶数';
        }
    }
    // 监听器
    onSerialChange() {
        this.updateSelectedSerialName();
        this.getSummaryData();
        this.getMonthlyData();
        this.getDeviceData();
        this.updateChart();
    }
    onYearChange() {
        this.getSummaryData();
        this.getMonthlyData();
        this.getDeviceData();
        this.updateChart();
    }
    onMonthChange() {
        // 月份切换时只需要更新设备列表数据，不需要更新汇总和月份统计数据
        this.getDeviceData();
    }
    onDeviceOptionsChange() {
        this.getDeviceData();
    }
    async mounted() {
        const that = this;
        const deviceSerial = String(that.routeQuery.serial);
        const deviceNo = that.routeQuery.no;
        that.getSerialList().then((ser) => {
            if (that.listSerial.length && deviceSerial.length) {
                that.listSerial.forEach((its) => {
                    if (its.serial.toLocaleLowerCase() === deviceSerial.toLowerCase()) {
                        that.searchOptions.serial = its.serial;
                    }
                });
            }
        });
        that.fetchHospitals();
        that.getSummaryData();
        that.getMonthlyData();
        that.getDeviceData();
        that.initChart();
    }
    beforeDestroy() {
        if (this.chart) {
            this.chart.dispose();
            this.chart = null;
        }
        // 移除窗口大小变化监听器
        window.removeEventListener('resize', this.handleResize);
        // 移除ResizeObserver
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
    }
    getSerialList() {
        const that = this;
        that.dialog.loading = true;
        return that.fetchDeviceSerialList().then(() => {
            that.dialog.loading = false;
            // 设置默认机型为第一个
            if (that.listSerial.length > 0 && !that.searchOptions.serial) {
                that.searchOptions.serial = that.listSerial[0].serial; // id
                that.updateSelectedSerialName();
            }
        }).catch((e) => {
            that.dialog.loading = false;
            console.log('error of get device serial: ', e);
            that.snackbar.error('获取设备机型列表出错');
        });
    }
    // 更新选中机型名称
    updateSelectedSerialName() {
        const selectedSerial = this.listSerial.find((s) => s.serial === this.searchOptions.serial);
        this.selectedSerialName = selectedSerial ? selectedSerial.serial : '';
    }
    async fetchList(_params) {
        const params = {
            ...this.searchOptions,
            ...(_params || {}),
        };
        this.deviceStabilityData = (await this.axios.get('/api/report/device-stability', { params: params }))?.data || {};
        return this.deviceStabilityData;
    }
    async getList() {
        const that = this;
        this.loading = true;
        try {
            that.fetchHospitals();
            that.initChart();
            that.getSummaryData();
            that.getMonthlyData();
            that.getDeviceData();
        }
        catch (error) {
            console.error('获取设备稳定性统计数据失败:', error);
            this.snackbar.error('获取数据失败');
        }
        finally {
            this.loading = false;
        }
    }
    async getSummaryData() {
        const that = this;
        try {
            const params = {
                serial: that.searchOptions.serial,
                year: that.searchOptions.year,
                type: 'summary'
            };
            const response = await that.fetchList(params);
            if (response.data) {
                // 确保返回的数据是数组格式
                const data = response.data || response.data.list;
                that.summary = data;
            }
            else {
                that.summary = {};
                that.snackbar.error(response.data?.message || '获取统计数据失败');
            }
        }
        catch (error) {
            console.error('获取统计数据失败:', error);
            that.summary = {};
            that.snackbar.error('获取统计数据失败');
        }
        finally {
        }
    }
    // 获取月份统计数据
    async getMonthlyData() {
        const that = this;
        if (!that.searchOptions.serial || !that.searchOptions.year)
            return;
        that.dataLoading.monthly = true;
        try {
            const params = {
                serial: that.searchOptions.serial,
                year: that.searchOptions.year,
                type: 'monthly'
            };
            const response = await that.fetchList(params);
            if (response.data) {
                // 确保返回的数据是数组格式
                const data = response.data.monthlyData || response.data.list;
                if (Array.isArray(data)) {
                    // 确保数据按月份排序，并包含所有12个月
                    const sortedData = data.sort((a, b) => a.month - b.month);
                    that.monthlyData = sortedData;
                }
                else if (data && typeof data === 'object') {
                    // 如果返回的是对象，转换为数组
                    const arrayData = Object.values(data);
                    const sortedData = arrayData.sort((a, b) => a.month - b.month);
                    that.monthlyData = sortedData;
                }
                else {
                    that.monthlyData = [];
                }
            }
            else {
                that.monthlyData = [];
                that.snackbar.error(response.data?.message || '获取月份统计数据失败');
            }
            that.updateChart();
        }
        catch (error) {
            console.error('获取月份统计数据失败:', error);
            that.monthlyData = [];
            that.snackbar.error('获取月份统计数据失败');
        }
        finally {
            that.dataLoading.monthly = false;
        }
    }
    // 获取设备数据
    async getDeviceData() {
        const that = this;
        if (!that.searchOptions.serial)
            return;
        that.dataLoading.device = true;
        try {
            const params = {
                serial: that.searchOptions.serial,
                year: that.searchOptions.year,
                month: that.searchOptions.month,
                type: 'list',
                page: that.deviceOptions.page,
                limit: that.deviceOptions.itemsPerPage
            };
            const response = await that.fetchList(params);
            if (response.data) {
                // 确保返回的数据是数组格式
                const data = response.data.deviceData || response.data.list;
                if (Array.isArray(data)) {
                    that.deviceData = data;
                }
                else if (data && typeof data === 'object') {
                    // 如果返回的是对象，转换为数组
                    that.deviceData = Object.values(data);
                }
                else {
                    that.deviceData = [];
                }
                that.deviceTotal = response.data.pagination.total;
                const summary = response.data.summary || {};
                that.deviceAverages = summary;
            }
            else {
                that.deviceData = [];
                that.snackbar.error(response.data?.message || '获取设备数据失败');
            }
        }
        catch (error) {
            console.error('获取设备数据失败:', error);
            that.deviceData = [];
            that.snackbar.error('获取设备数据失败');
        }
        finally {
            that.dataLoading.device = false;
        }
    }
    // 初始化图表
    initChart() {
        const that = this;
        that.$nextTick(() => {
            const chartDom = document.getElementById('stability-chart');
            if (chartDom) {
                that.chart = that.$echarts.init(chartDom, null, {
                    renderer: 'canvas',
                    useDirtyRect: false
                });
                that.updateChart();
                // 添加窗口大小变化监听
                window.addEventListener('resize', that.handleResize);
                // 添加容器大小变化监听
                if (window.ResizeObserver) {
                    that.resizeObserver = new window.ResizeObserver(() => {
                        that.handleResize();
                    });
                    that.resizeObserver.observe(chartDom);
                }
            }
        });
    }
    // 处理窗口大小变化
    handleResize() {
        const that = this;
        if (that.chart) {
            // 延迟执行resize，确保DOM更新完成
            setTimeout(() => {
                that.chart.resize();
            }, 100);
        }
    }
    // 更新图表
    async updateChart() {
        const that = this;
        if (!that.chart)
            return;
        that.dataLoading.chart = true;
        try {
            const params = {
                serial: that.searchOptions.serial,
                year: that.searchOptions.year,
                type: 'chart'
            };
            const response = that.monthlyData; // await that.fetchList(params)
            if (response) {
                const chartData = response || [];
                // 响应式配置
                const isMobile = window.innerWidth <= 600;
                const isTablet = window.innerWidth <= 960;
                const option = {
                    title: {
                        text: '设备稳定性趋势图',
                        left: 'center',
                        textStyle: {
                            fontSize: isMobile ? 12 : isTablet ? 14 : 16,
                            fontWeight: 'bold'
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross'
                        },
                        confine: true,
                        textStyle: {
                            fontSize: isMobile ? 10 : 12
                        }
                    },
                    legend: {
                        data: ['MTBF', '去除人为的平均故障间隔时间（MTBF）', '故障次数'],
                        top: isMobile ? 25 : 30,
                        type: 'scroll',
                        orient: 'horizontal',
                        textStyle: {
                            fontSize: isMobile ? 10 : 12
                        },
                        itemWidth: isMobile ? 15 : 25,
                        itemHeight: isMobile ? 10 : 14
                    },
                    grid: {
                        left: isMobile ? '15%' : '10%',
                        right: isMobile ? '15%' : '10%',
                        bottom: isMobile ? '20%' : '15%',
                        top: isMobile ? '25%' : '20%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: chartData.map((item) => `${item.month}月`),
                        axisLabel: {
                            fontSize: isMobile ? 10 : 12,
                            rotate: isMobile ? 45 : 0
                        }
                    },
                    yAxis: [
                        {
                            type: 'value',
                            name: 'MTBF/瓶数',
                            position: 'left',
                            nameTextStyle: {
                                fontSize: isMobile ? 10 : 12
                            },
                            axisLabel: {
                                fontSize: isMobile ? 10 : 12
                            }
                        },
                        {
                            type: 'value',
                            name: '故障次数',
                            position: 'right',
                            nameTextStyle: {
                                fontSize: isMobile ? 10 : 12
                            },
                            axisLabel: {
                                fontSize: isMobile ? 10 : 12
                            }
                        }
                    ],
                    series: [
                        {
                            name: 'MTBF',
                            type: 'line',
                            yAxisIndex: 0,
                            data: chartData.map((item) => item.mtbf),
                            smooth: true,
                            itemStyle: {
                                color: '#1976d2'
                            }
                        },
                        {
                            name: '去除人为的平均故障间隔时间（MTBF）',
                            type: 'line',
                            yAxisIndex: 0,
                            data: chartData.map((item) => item.mtbfExcludeHuman),
                            smooth: true,
                            itemStyle: {
                                color: '#388e3c'
                            }
                        },
                        {
                            name: '故障次数',
                            type: 'line',
                            yAxisIndex: 1,
                            data: chartData.map((item) => item.totalFaults),
                            smooth: true,
                            itemStyle: {
                                color: '#f57c00'
                            }
                        }
                    ]
                };
                that.chart.setOption(option);
            }
        }
        catch (error) {
            console.error('更新图表失败:', error);
        }
        finally {
            that.dataLoading.chart = false;
        }
    }
    // 导出设备稳定性报告
    /**
     * 导出设备稳定性统计报告
     * @author vacant <wq.chen@broadcare.com.cn>
     * @date 2025/09/10
     * @description 导出包含月份统计、设备使用情况和汇总数据的完整报告
     */
    async exportIntegratedReport() {
        try {
            const params = {
                serial: this.searchOptions.serial,
                year: this.searchOptions.year,
            };
            const response = await this.axios.post('/api/report/device-stability/export', params, {
                responseType: 'blob'
            });
            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const monthText = this.searchOptions.month ? `${this.searchOptions.month}月` : '全年';
            link.download = `设备稳定性统计报告_${this.selectedSerialName}_${this.searchOptions.year}年${monthText}_${new Date().toISOString().slice(0, 10)}.xlsx`;
            link.click();
            window.URL.revokeObjectURL(url);
            this.snackbar.success('导出成功');
        }
        catch (error) {
            console.error('导出失败:', error);
            this.snackbar.error('导出失败');
        }
    }
    viewDetail(item) {
        this.formData = { ...item };
        this.dialog.title = `设备稳定性详情 - ${item.deviceName || item.deviceNo}`;
        this.dialog.visible = true;
    }
    closeDialog() {
        this.dialog.visible = false;
        this.formData = {};
    }
    // 工具方法
    truncateText(text, maxLength) {
        if (!text || text.length <= maxLength)
            return text;
        return text.substring(0, maxLength) + '...';
    }
    formatDateTime(dateTime) {
        if (!dateTime)
            return '-';
        return new Date(dateTime).toLocaleString('zh-CN');
    }
    // 颜色辅助方法
    getSuccessRateColor(rate) {
        if (rate >= 95)
            return 'success';
        if (rate >= 90)
            return 'warning';
        return 'error';
    }
    getSuccessRateTextColor(rate) {
        if (rate >= 95)
            return 'success--text';
        if (rate >= 90)
            return 'warning--text';
        return 'error--text';
    }
    getMtbfColor(mtbf) {
        if (mtbf >= 72)
            return 'success--text'; // 3天
        if (mtbf >= 24)
            return 'warning--text'; // 1天
        return 'error--text';
    }
    getMtbfTextColor(mtbf) {
        if (mtbf >= 72)
            return 'success--text'; // 3天
        if (mtbf >= 24)
            return 'warning--text'; // 1天
        return 'error--text';
    }
    getSuccRateTextColor(rate) {
        if (rate >= 95)
            return 'success--text';
        if (rate >= 80)
            return 'warning--text';
        return 'error--text';
    }
    getStabilityLevelColor(level) {
        switch (level) {
            case '优秀': return 'success';
            case '良好': return 'info';
            case '一般': return 'warning';
            case '较差': return 'error';
            default: return 'grey';
        }
    }
    getDaysWithoutFaultColor(days) {
        if (days >= 30)
            return 'success--text';
        if (days >= 15)
            return 'warning--text';
        return 'error--text';
    }
    getDaysWithoutFaultTextColor(days) {
        if (days >= 30)
            return 'success--text';
        if (days >= 15)
            return 'warning--text';
        return 'error--text';
    }
};
__decorate([
    Getter('deviceSerialList')
], DeviceStability.prototype, "listSerial", void 0);
__decorate([
    Getter('hospitalsList')
], DeviceStability.prototype, "hospitalsList", void 0);
__decorate([
    Getter('hospitalsLoading')
], DeviceStability.prototype, "hospitalsLoading", void 0);
__decorate([
    Action
], DeviceStability.prototype, "fetchDeviceSerialList", void 0);
__decorate([
    Action('fetchHospitals')
], DeviceStability.prototype, "fetchHospitals", void 0);
__decorate([
    Watch('searchOptions.serial')
], DeviceStability.prototype, "onSerialChange", null);
__decorate([
    Watch('searchOptions.year')
], DeviceStability.prototype, "onYearChange", null);
__decorate([
    Watch('searchOptions.month')
], DeviceStability.prototype, "onMonthChange", null);
__decorate([
    Watch('deviceOptions', { deep: true })
], DeviceStability.prototype, "onDeviceOptionsChange", null);
DeviceStability = __decorate([
    Component({
        name: 'DeviceStability',
        components: {
            BcDialog,
            BcSnackbar,
        }
    })
], DeviceStability);
export default DeviceStability;
